import React from 'react'

const RightChevron = () => (
  <svg width="15" height="12" viewBox="0 0 15 12" xmlns="http://www.w3.org/2000/svg"><g className="fill-current" fillRule="evenodd"><path d="M.003 0l5.459 6L0 11.997 2.535 12 8 6 2.535 0z"/><path d="M7.003 0l5.459 6L7 11.997 9.535 12 15 6 9.535 0z"/></g></svg>
)

export default RightChevron
